import { SpecimensAndSamplesComponent } from './components/specimens-and-samples/specimens-and-samples.component';
import { SampleViewerComponent } from './components/sample-viewer/sample-viewer.component';
import { AddSampleComponent } from './components/sample-viewer/add-sample/add-sample.component';
import { SampleListComponent } from './components/sample-viewer/sample-list/sample-list.component';
import { NavicanSampleFormComponent } from './components/sample-viewer/add-sample/navican-sample-form/navican-sample-form.component';
import { NavicanSampleComponent } from './components/sample-viewer/sample-list/sample-types/navican-sample/navican-sample.component';
import { NormalSpecimenComponent } from './components/sample-viewer/sample-list/sample-types/normal-specimen/normal-specimen.component';
import { TumorSpecimenComponent } from './components/sample-viewer/sample-list/sample-types/tumor-specimen/tumor-specimen.component';
import { SampleGenericComponent } from './components/sample-viewer/sample-list/sample-types/sample-generic/sample-generic.component';
import { DynamicSpecimenComponent } from './components/sample-viewer/sample-list/sample-types/dynamic-specimen/dynamic-specimen.component';

import { SpecimensAndSamplesService } from './services/specimens-and-samples.service';
import { SpecimensAndSamplesActionsService } from './services/specimens-and-samples-actions-service';
import { DynamicRequiredFieldsComponent } from "./components/sample-viewer/sample-list/sample-types/dynamic-required-fields/dynamic-required-fields.component";
import { SpecimenTypeComponent } from "@ispm/migration/components/specimenDirectives/specimen-type/specimen-type.component";


export const COMPONENTS = [SpecimensAndSamplesComponent, SampleViewerComponent, SpecimenTypeComponent];
export const SERVICES = [SpecimensAndSamplesService];

export const specimensAndSamplesComponents = [
  SampleViewerComponent,
  AddSampleComponent,
  SampleListComponent,
  NavicanSampleFormComponent,
  NavicanSampleComponent,
  NormalSpecimenComponent,
  TumorSpecimenComponent,
  SampleGenericComponent,
  DynamicSpecimenComponent,
  DynamicRequiredFieldsComponent
];

export const specimensAndSamplesServices = [
  SpecimensAndSamplesActionsService
];
